var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRectangleButtonRight2 = function SvgRectangleButtonRight2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.643,
    height: 107.957,
    viewBox: "0 0 87.643 107.957"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M43.656.1Q21.854,27.018,0,53.88c7.789,9.854,15.868,19.558,23.748,29.375,6.725,8.209,13.374,16.526,20.109,24.7C58.534,90.065,73.02,71.991,87.643,54.044c-2.018-3.076-4.743-5.836-6.971-8.83C68.349,30.17,56.153,15.007,43.8,0Z",
    transform: "translate(87.643 107.957) rotate(180)",
    fill: "#002238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow_2_",
    d: "M-937,921.086l.808.808,6.119-6.119-6.119-6.119-.808.808,5.311,5.311L-937,921.086Z",
    transform: "translate(977.357 -861.796)",
    fill: "#ffebc3",
    fillRule: "evenodd"
  }))));
};

export { SvgRectangleButtonRight2 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4Ny42NDMiIGhlaWdodD0iMTA3Ljk1NyIgdmlld0JveD0iMCAwIDg3LjY0MyAxMDcuOTU3Ij4KICA8ZyBpZD0iR3JvdXBfODgiIGRhdGEtbmFtZT0iR3JvdXAgODgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDApIj4KICAgIDxwYXRoIGlkPSJVbmlvbl8yIiBkYXRhLW5hbWU9IlVuaW9uIDIiIGQ9Ik00My42NTYuMVEyMS44NTQsMjcuMDE4LDAsNTMuODhjNy43ODksOS44NTQsMTUuODY4LDE5LjU1OCwyMy43NDgsMjkuMzc1LDYuNzI1LDguMjA5LDEzLjM3NCwxNi41MjYsMjAuMTA5LDI0LjdDNTguNTM0LDkwLjA2NSw3My4wMiw3MS45OTEsODcuNjQzLDU0LjA0NGMtMi4wMTgtMy4wNzYtNC43NDMtNS44MzYtNi45NzEtOC44M0M2OC4zNDksMzAuMTcsNTYuMTUzLDE1LjAwNyw0My44LDBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4Ny42NDMgMTA3Ljk1Nykgcm90YXRlKDE4MCkiIGZpbGw9IiMwMDIyMzgiLz4KICAgIDxwYXRoIGlkPSJhcnJvd18yXyIgZD0iTS05MzcsOTIxLjA4NmwuODA4LjgwOCw2LjExOS02LjExOS02LjExOS02LjExOS0uODA4LjgwOCw1LjMxMSw1LjMxMUwtOTM3LDkyMS4wODZaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5NzcuMzU3IC04NjEuNzk2KSIgZmlsbD0iI2ZmZWJjMyIgZmlsbC1ydWxlPSJldmVub2RkIi8+CiAgPC9nPgo8L3N2Zz4K";